module.exports = __webpack_public_path__ + "6e20ce306290d2b87bb5b62f51ef40a2.pdf";